import moment from 'moment';
import _ from 'lodash';
import { getProjects } from './graphql';
import UndismissBtn from './undismiss-btn';
import textFilterComponent from '../../../core/components/filterable-grid/text-filter-component';

export const columns = [
  { headerName: 'Workspace name', field: 'workspaceName' },
  {
    headerName: 'Project name', field: 'projectName', filter: textFilterComponent, type: 'text',
  },
  { headerName: 'Status', field: 'status' },
  { headerName: 'Customer user who launched it', field: 'fullName' },
  { headerName: 'Email of the customer who launched it', field: 'email' },
  { headerName: 'Type of study', field: 'projectType' },
  { headerName: 'Audience type', field: 'participantsSource' },
  { headerName: 'Date & Time launched', field: 'createdAt' },
  { headerName: 'Date / time closed', field: 'completedAt' },
  { headerName: 'Fill time', field: 'fillTime' },
  { headerName: '# testers requested', field: 'participantsNumber' },
  { headerName: '# testers qualified', field: 'qualifiedTestersNumber' },
  { headerName: '# testers who took the screener ', field: 'testersNumberWithScreener' },
  { headerName: '# testers who signed up / snoozed it', field: 'playbookTestersNumber' },
  { headerName: '# testers taking it now', field: 'testersTakingStudy' },
  { headerName: '# testers COMPLETED', field: 'completedTestersNumber' },
  { headerName: '# testers PROCESSING', field: 'processingTestersNumber' },
  { headerName: '# testers PROCESSED (VIDEOS RECEIVED)', field: 'processedTestersNumber' },
  { headerName: '# of testers disqualified', field: 'disqualifiedTestersNumber' },
  {
    headerName: 'Approvals',
    field: 'action',
    width: 100,
    cellRenderer: UndismissBtn,
  },
  { headerName: 'Test #', field: 'testCode' },
];

export const getPaginatedProjects = async (params) => {
  let rows = [];
  try {
    const { projects, projectsCount } = await getProjects(params);

    if (projects) {
      rows = _.map(projects, (project) => ({
        workspaceName: project.company.name,
        projectName: project.name,
        status: _.startCase(_.replace(project.status, '_', ' ')),
        fullName: `${project.createdBy.profile.firstName} ${project.createdBy.profile.lastName}`,
        email: project.createdBy.email,
        projectType: _.replace(project.testType, '_', ' '),
        participantsSource: project.participantsSource === 'playbook' ? 'PlaybookUX' : 'Bring your own participants',
        createdAt: moment(project.createdAt).format('MM/DD/YYYY hh:mm A'),
        completedAt: project.completedAt ? moment(project.completedAt).format('MM/DD/YYYY hh:mm A') : '0:00',
        fillTime: project.completedAt ? moment(project.completedAt).diff(project.createdAt, 'hours') : '-',
        participantsNumber: project.audienceParticipants,
        qualifiedTestersNumber: project.qualifiedTestersNumber || '-',
        testersNumberWithScreener: project.testersNumberWithScreener,
        participantsPuxNumber: project.participantsPuxNumber || '-',
        playbookTestersNumber: project.playbookTestersNumber || '-',
        testersTakingStudy: project.testersTakingStudy || '-',
        completedTestersNumber: project.completedTestersNumber || '-',
        processingTestersNumber: project.processingTestersNumber || '-',
        processedTestersNumber: project.processedTestersNumber || '-',
        disqualifiedTestersNumber: project.disqualifiedTestersNumber || '-',
        projectId: project.id,
        testCode: project.shareCode || '-',
      }));
    }

    return {
      records: rows,
      totalRecords: projectsCount,
    };
  } catch (error) {
    throw new Error(error);
  }
};

export const keys = {
  workspaceName: '',
  projectName: '',
  status: '',
  fullName: '',
  email: '',
  projectType: '',
  participantsSource: '',
  createdAt: '',
  completedAt: '',
  fillTime: '',
  participantsNumber: '',
  qualifiedTestersNumber: '',
  testersNumberWithScreener: '',
  participantsPuxNumber: '',
  playbookTestersNumber: '',
  testersTakingStudy: '',
  completedTestersNumber: '',
  processingTestersNumber: '',
  processedTestersNumber: '',
  disqualifiedTestersNumber: '',
  projectId: '',
  testCode: '',
};
